import ResetpasswordForm from '../model/form.model';

class FormController {
  constructor(AccountApiService, FormService, $timeout, $translate, $location) {
    'ngInject';

    this.AccountApiService = AccountApiService;
    this.FormService = FormService;
    this.$timeout = $timeout;
    this.$translate = $translate;
    this.$location = $location;
  }

  $onInit() {
    this.form = new ResetpasswordForm();
  }

  submitForm() {
    const locale = this.$location.search().lang || 'en';
    this.$translate.use(locale);

    this.FormService.isSubmitting.next(true);
    this.AccountApiService.resetPassword(locale, this.form.toPayload())
    .then((resp) => {
      this.form.error = '';
      this.form.success = this.$translate.instant('Password changed.');
      this.$timeout(() => {
        parent.postMessage('amsReset-success', '*' );
      }, 1500);
    })
    .catch((error) => {
      this.form.success = '';
      this.form.error = error.children.password.children.first.errors[0];
    })
    .finally(() => this.FormService.isSubmitting.next(false))
    ;
  }

  sendPostMessageToForgotPass() {
    parent.postMessage('amsForgot-pass', '*');
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/resetpassword/component/form.controller.js